import {useState} from 'react';

export const initialAsyncActionState = {
    result: null,
    error: null,
    processing: false,
};

export default function useAsyncAction(
    action,
    onSuccess,
    onError,
) {
    const [state, setState] = useState(initialAsyncActionState);

    const startAction = async (...args) => {
        setState({
            ...initialAsyncActionState,
            processing: true,
        });

        try {
            const result = await action(...args);

            setState({
                ...state,
                result,
                error: null,
                processing: false,
            });

            if (onSuccess) {
                onSuccess(result, ...args);
            }
        } catch (err) {
            setState({
                ...initialAsyncActionState,
                error: err,
                processing: false,
            });

            if (onError) {
                onError(err, ...args);
            }
        }
    };
    startAction.key = Math.random();

    const reset = () => setState(initialAsyncActionState);

    return [{...state, reset}, startAction];
}



// WEBPACK FOOTER //
// ./src/components/helpers/hooks/useAsyncAction.js